import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { SEOEyebrowLink, SEOSubjectLink, SEOSubSubjectLink } from '../styles';
import { SEOLinkType } from '../types';
import { useLinkBehavior } from '../shared';
export var SEOLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var linkType = props.linkType,
      nofollow = props.nofollow,
      linkProps = _objectWithoutProperties(props, ["linkType", "nofollow"]);

  var relValue = nofollow ? 'nofollow' : undefined;

  var _useLinkBehavior = useLinkBehavior(linkProps),
      linkBehavior = _extends({}, _useLinkBehavior);

  switch (linkType) {
    case SEOLinkType.Subject:
      return /*#__PURE__*/React.createElement(SEOSubjectLink, _extends({
        ref: ref,
        rel: relValue
      }, linkProps, linkBehavior));

    case SEOLinkType.SubSubject:
      return /*#__PURE__*/React.createElement(SEOSubSubjectLink, _extends({
        ref: ref,
        rel: relValue
      }, linkProps, linkBehavior));

    case SEOLinkType.Eyebrow:
    default:
      return /*#__PURE__*/React.createElement(SEOEyebrowLink, _extends({
        ref: ref,
        rel: relValue
      }, linkProps, linkBehavior));
  }
});
SEOLink.displayName = 'SEOLink';
SEOLink.defaultProps = {
  nofollow: true
};
export default SEOLink;